import AdminPanel from './AdminPanel';

export default AdminPanel;
